import type {
	AccountingIntegration,
	CheckAccountingIntegrationResponse,
	CreateAccountingIntegrationRequest,
	CreateAccountingIntegrationResponse,
	GetAccountingIntegrationResponse,
	ListAccountingIntegrationsResponse,
	ListIntegrationChecksResponse,
	SyncQueueJob,
	UpdateAccountingIntegrationRequest,
	UpdateAccountingIntegrationResponse,
} from "@elastic/accounting-sync-api";
import crud from "@/api/crud";

export type { AccountingIntegration, SyncQueueJob };

export const AccountingIntegrationsAPI = (baseUrl: string) => {
	return {
		list: async (page = 1, limit = 20) => {
			return (await crud.get(
				`${baseUrl}/accounting/integrations`,
				[
					{ key: "page", value: page },
					{ key: "limit", value: limit },
				],
				true,
			)) as ListAccountingIntegrationsResponse;
		},
		get: async (id: number) => {
			return (await crud.get(
				`${baseUrl}/accounting/integrations/${id}`,
				undefined,
				true,
			)) as GetAccountingIntegrationResponse;
		},
		create: async (integration: CreateAccountingIntegrationRequest) => {
			return (await crud.post(
				`${baseUrl}/accounting/integrations`,
				integration,
				true,
			)) as CreateAccountingIntegrationResponse;
		},
		update: async (
			id: number,
			integration: UpdateAccountingIntegrationRequest,
		) => {
			return (await crud.put(
				`${baseUrl}/accounting/integrations/${id}`,
				integration,
				true,
			)) as UpdateAccountingIntegrationResponse;
		},
		delete: async (id: number) => {
			return (await crud.delete(
				`${baseUrl}/accounting/integrations/${id}`,
				true,
			)) as object;
		},
		check: async (id: number) => {
			return (await crud.get(
				`${baseUrl}/accounting/integrations/${id}/check`,
				undefined,
				true,
			)) as CheckAccountingIntegrationResponse;
		},
		listChecks: async (id: number, page = 1, limit = 20) => {
			return (await crud.get(
				`${baseUrl}/accounting/integrations/${id}/status`,
				[
					{ key: "page", value: page },
					{ key: "limit", value: limit },
				],
				true,
			)) as ListIntegrationChecksResponse;
		},
	};
};
